import { fetchSettings } from "../../services/api";

export default {
  namespaced: true,
  state: {
    price_double_pillar: 0,
  },
  getters: {
    priceDoublePillar(state) {
      return state.price_double_pillar;
    },
  },
  actions: {
    fetch: ({ commit, rootState }) => {
      return fetchSettings(rootState.environmentId).then(({ data }) => {
        commit('SET_PRICE', +data.price_double_pillar);
      });
    },
  },
  mutations: {
    SET_PRICE: (state, data) => {
      state.price_double_pillar = data;
    },
  },
};
